// import React from "react";
// import ChapterPuzzlePiece from "../ChapterPuzzlePiece";
// import {getData} from "../../requests/CRUD";
// import {sortArray} from "../../utils";
// import {TRAINING} from "../../consts/tables";

// export default class extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             chapters: [],
//             hoveredTitle: '',
//             isHovered: false,
//         };

//         this.onMouseEnter = this.onMouseEnter.bind(this);
//         this.onMouseLeave = this.onMouseLeave.bind(this);
//     }

//     componentDidMount() {
//         getData({
//             tableCode: TRAINING,
//             options: {
//                 filter: [{
//                     text: '',
//                     code: 'DELETED',
//                     type: 'null',
//                 }, {
//                     text: 'training',
//                     code: 'PARENT_SLUG',
//                     type: 'exact',
//                 }],
//                 filterType: 'and',
//             },
//         }).then(res => {
//             if (res && res.success && Array.isArray(res.data) && res.data.length) {
//                 const chapters = sortArray(
//                     res.data.map(chapter => {
//                         return {
//                             id: chapter.SLUG,
//                             name: chapter.NAME,
//                             svg: `${arc.path.media}${chapter.PHOTO}`,
//                             index: parseInt(chapter.INDEX),
//                         }
//                     }), 'index');
//                 this.setState({chapters});
//             }
//         });
//     }

//     onMouseEnter(index) {
//         this.setState({
//             hoveredTitle: this.state.chapters[index - 1].name,
//             isHovered: true,
//         });
//     }

//     onMouseLeave() {
//         this.setState({isHovered: false});
//     }

//     render() {
//         const {chapters, hoveredTitle, isHovered} = this.state;

//         return (
//             <div className='Training'>
//                 <div className='page-rounded-corner-container'>
//                     <div className='page-header-container'>
//                         <div className='page-header'>
//                             <div className='page-title'>Training</div>
//                         </div>
//                         <div className='line'/>
//                     </div>
//                 </div>
//                 <div className='page-body-container center'>
//                     <div className='chapters-container'>
//                         {
//                             chapters.map(chapter =>
//                                 <div className='chapter-container' key={chapter.id}>
//                                     <ChapterPuzzlePiece
//                                         id={chapter.id}
//                                         index={chapter.index}
//                                         svg={chapter.svg}
//                                         onMouseEnter={this.onMouseEnter}
//                                         onMouseLeave={this.onMouseLeave}
//                                     />
//                                 </div>
//                             )
//                         }
//                         <div className={`chapter-title ${isHovered ? 'visible' : ''}`}>{hoveredTitle}</div>
//                     </div>
//                 </div>
//             </div>
//         )
//     }
// }
//#region  Old Code
// import React from "react";
// import ChapterPuzzlePiece from "../ChapterPuzzlePiece";
// import {getData} from "../../requests/CRUD";
// import {sortArray} from "../../utils";
// import {TRAINING} from "../../consts/tables";

// export default class extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             chapters: [],
//             hoveredTitle: '',
//             isHovered: false,
//         };

//         this.onMouseEnter = this.onMouseEnter.bind(this);
//         this.onMouseLeave = this.onMouseLeave.bind(this);
//     }

//     componentDidMount() {
//         getData({
//             tableCode: TRAINING,
//             options: {
//                 filter: [{
//                     text: '',
//                     code: 'DELETED',
//                     type: 'null',
//                 }, {
//                     text: 'training',
//                     code: 'PARENT_SLUG',
//                     type: 'exact',
//                 }],
//                 filterType: 'and',
//             },
//         }).then(res => {
//             if (res && res.success && Array.isArray(res.data) && res.data.length) {
//                 const chapters = sortArray(
//                     res.data.map(chapter => {
//                         return {
//                             id: chapter.SLUG,
//                             name: chapter.NAME,
//                             svg: `${arc.path.media}${chapter.PHOTO}`,
//                             index: parseInt(chapter.INDEX),
//                         }
//                     }), 'index');
//                 this.setState({chapters});
//             }
//         });
//     }

//     onMouseEnter(index) {
//         this.setState({
//             hoveredTitle: this.state.chapters[index - 1].name,
//             isHovered: true,
//         });
//     }

//     onMouseLeave() {
//         this.setState({isHovered: false});
//     }

//     render() {
//         const {chapters, hoveredTitle, isHovered} = this.state;

//         return (
//             <div className='Training'>
//                 <div className='page-rounded-corner-container'>
//                     <div className='page-header-container'>
//                         <div className='page-header'>
//                             <div className='page-title'>Training</div>
//                         </div>
//                         <div className='line'/>
//                     </div>
//                 </div>
//                 <div className='page-body-container center'>
//                     <div className='chapters-container'>
//                         {
//                             chapters.map(chapter =>
//                                 <div className='chapter-container' key={chapter.id}>
//                                     <ChapterPuzzlePiece
//                                         id={chapter.id}
//                                         index={chapter.index}
//                                         svg={chapter.svg}
//                                         onMouseEnter={this.onMouseEnter}
//                                         onMouseLeave={this.onMouseLeave}
//                                     />
//                                 </div>
//                             )
//                         }
//                         <div className={`chapter-title ${isHovered ? 'visible' : ''}`}>{hoveredTitle}</div>
//                     </div>
//                 </div>
//             </div>
//         )
//     }
// }

//#endregion


import React from "react";
import ChapterPuzzlePiece from "../ChapterPuzzlePiece";
import { getData } from "../../requests/CRUD";
import { sortArray } from "../../utils";
import { TRAINING } from "../../consts/tables";
import { ApolloConsumer } from "@apollo/client";
//import { GET_TRAINING } from "../Graphql/Queries/TrainingQuery";
import { GET_TRAINING,GET_TRAINING_CONTENT } from "../Graphql/Queries/TrainingQuery";
import { fetchData } from "../Service/graphQlService";

export default class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            chapters: [],
            hoveredTitle: '',
            isHovered: false,
        };
        this.client = null;
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
    }

    componentDidMount() {
        
        // this.client.query({
        //     query: GET_TRAINING, variables: {
        //         filter: [{ text: '', code: 'DELETED', type: 'null' },
        //         { text: 'training', code: 'PARENT_SLUG', type: 'exact' }],
        //         filterType: 'and'
        //     }
        let payloadFilter = {
            "PARENT_SLUG": "training"
          }
        const token = localStorage.getItem('authToken');
        // this.client.query({
        //     query: GET_TRAINING,variables:{filters:payloadFilter},fetchPolicy: "no-cache",
        //     context: {
        //         headers: {
        //             authorization: `Bearer ${token}`, // Bearer token added here
        //         },
        //     }
        // })
        fetchData(GET_TRAINING, {filters:payloadFilter})
        .then(res => {
                if (res && res.data && Array.isArray(res.data.getTrainingFilter.data) && res.data.getTrainingFilter.data.length) {
                    const chapters = sortArray(
                        res.data.getTrainingFilter.data.map(chapter => {
                            return {
                                id: chapter.SLUG,
                                name: chapter.NAME,
                                svg: chapter.PHOTO,
                                index: parseInt(chapter.INDEX),
                            }
                        }), 'index');
                    this.setState({ chapters });
                }
            });
    }

    onMouseEnter(index) {
        this.setState({
            hoveredTitle: this.state.chapters[index - 1].name,
            isHovered: true,
        });
    }

    onMouseLeave() {
        this.setState({ isHovered: false });
    }

    render() {
        const { chapters, hoveredTitle, isHovered } = this.state;

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (
                        <div className='Training'>
                            <div className='page-rounded-corner-container'>
                                <div className='page-header-container'>
                                    <div className='page-header'>
                                        <div className='page-title'>Training</div>
                                    </div>
                                    <div className='line' />
                                </div>
                            </div>
                            <div className='page-body-container center'>
                                <div className='chapters-container'>
                                    {
                                        chapters.map(chapter =>
                                            <div className='chapter-container' key={chapter.id}>
                                                <ChapterPuzzlePiece
                                                    id={chapter.id}
                                                    index={chapter.index}
                                                    svg={chapter.svg}
                                                    onMouseEnter={this.onMouseEnter}
                                                    onMouseLeave={this.onMouseLeave}
                                                />
                                            </div>
                                        )
                                    }
                                    <div className={`chapter-title ${isHovered ? 'visible' : ''}`}>{hoveredTitle}</div>
                                </div>
                            </div>
                        </div>
                    )
                }}
            </ApolloConsumer>

        )
    }
}